export default "__VITE_ASSET__eff086aa__"